import React from 'react';
import I18n from 'app/i18n';

const KnowledgeCenterEmptyState = (): React.ReactElement => <div className="knowledge-center knowledge-center--article">
    <div className="knowledge-center__body">
        <p className="knowledge-center__empty">{I18n.t('global.nothing_found')}</p>
    </div>
</div>;

export default KnowledgeCenterEmptyState;
